import axios from 'axios';
import { kebabCase } from 'lodash';
import { v4 as uuid } from 'uuid';
import {get, getJSON, set} from 'js-cookie';
import config from 'js/config';
import { isAnalyticsAccepted, getCookieValue } from 'js/utils/cookie';
import { ANONYMOUS_EVENTS } from 'js/config/footfallEventTypes';

const isProduction = !config.env.devOrStaging;
const isUserBot = navigator && /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
let membershipId = null;
let deviceId = null;

export async function trackFootfallEvent(type, data = {}) {
  if (isUserBot) return;

  const isAnonymous = !isAnalyticsAccepted();
  if (isAnonymous && !ANONYMOUS_EVENTS.includes(type)) return;

  await setMembershipAndDeviceIds(isAnonymous);

  if (!isValidEvent(type, data)) {
    return console.info('Footfall data not valid', type);
  }

  const extendedData = {
    'device-id': deviceId,
    'event-type': type,
    'membership-id': membershipId,
    'referrer': getReferrer(isAnonymous),
    'session-id': getSessionId(isAnonymous),
    'source': getSource(),
    'url': `${window.location.pathname}${window.location.search}`.replace(/\s/g, '%20'), // replace whitespace in URL
    ...convertKeysToKebabCase(data),
  };

  if (!isProduction) {
    await axios.post(
      config.build.footfallUrl,
      JSON.stringify(extendedData),
    ).catch(err => console.info(err, 'Error posting to Footfall'));
  } else {
    await axios.post(
      config.build.footfallUrl,
      JSON.stringify(extendedData),
    ).catch(err => console.info(err, 'Error posting to Footfall'));
  }
}

// await trackFootfallEvent before changing href
export async function trackFootfallEventWithHrefDelay(href, type, data) {
  await trackFootfallEvent(type, data);
  window.location.href = href;
}

// Some events require certain keys, ideally these would be TS types!
// See for requirements: https://github.com/HealthUnlocked/footfall/blob/master/src/cljc/footfall/events.cljc
function isValidEvent(type, data) {
  switch (type) {
    case 'clicked':
      return data.hasOwnProperty('clickType');
    case 'viewed-post':
      return data.hasOwnProperty('postId');
    case 'viewed-featured-post':
      return data.hasOwnProperty('featuredPostId');
    default:
      return true;
  }
}

function convertKeysToKebabCase(data) {
  const formattedData = {};
  Object.keys(data).forEach((key) => formattedData[kebabCase(key)] = data[key]);
  return formattedData;
}

function getSource() {
  return `Betelgeuse${get('huBv') || ''}`;
}

function getReferrer(isAnonymous) { // [CHAOS-131]
  if (isAnonymous) return '';
  if (document.referrer.includes('healthunlocked.com')) {
    const huReferrer = getCookieValue('huReferrer');
    if (huReferrer || huReferrer === '') {
      return huReferrer;
    }
  }
  return document.referrer;
}

function getSessionId(isAnonymous) {
  if (isAnonymous) return '';
  const session = getJSON('FOOTFALL_SESSION');
  const sessionId = session && session.sessionId ? session.sessionId : uuid();
  if (!session) {
    set('FOOTFALL_SESSION', { sessionId }, {expires: 30, path: '/'});
  }
  return sessionId;
}

async function setMembershipAndDeviceIds(isAnonymous) {
  if (isAnonymous) {
    deviceId = '';
    membershipId = '';
  } else if (!membershipId || !deviceId) {
    const response = await axios.get(`${config.build.apiPath}/session/info`).catch(err => console.info(err, 'Error getting session info'));
    if (response && response.data && response.data.meta && response.data.meta.session) {
      const sessionData = response.data.meta.session.split(':');
      if (Array.isArray(sessionData)) {
        deviceId = sessionData[0];
        membershipId = sessionData[1];
      }
    }
  }
}

export function clearTrackingSession() {
  membershipId = null;
  deviceId = null;
}



// WEBPACK FOOTER //
// ./app/assets/js/footfall.js